import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('sales-contract', storeModule.createStoreModule('sales-contract'))
